module.exports = __webpack_public_path__ + "img/a5t99-x5dbj.dbdf108f.png";